var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "m20 31.172-6.586-6.586-2.828 2.828L20 36.828l19.414-19.414-2.828-2.828z"
  })));
};
export { SvgCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5Ljk5OTkgMzEuMTcxOUwxMy40MTM5IDI0LjU4NTlMMTAuNTg1OSAyNy40MTM5TDE5Ljk5OTkgMzYuODI3OUwzOS40MTM5IDE3LjQxMzlMMzYuNTg1OSAxNC41ODU5TDE5Ljk5OTkgMzEuMTcxOVoiIGZpbGw9IiM5MDlBOUYiLz4KPC9zdmc+Cg==";